import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceSetupServiceParametersView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceSetupServiceParametersView, _super);
    function DeviceSetupServiceParametersView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.runtime = 567; //TODO
        _this.serviceIntervals = [];
        _this.lastRuntime = null;
        _this.loading = false;
        _this.saved = false;
        _this.warningMessage = null;
        return _this;
    }
    DeviceSetupServiceParametersView.prototype.mounted = function () {
        this.getIntervals();
    };
    DeviceSetupServiceParametersView.prototype.sendServiceData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var updatedIntervals;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.serviceIntervals.forEach(function (element) {
                            if (!element.new)
                                element.new = 0;
                        });
                        this.loading = true;
                        return [4 /*yield*/, axios.post("devicesensorlog/setintervals", { serialNumber: this.device.serial,
                                blade: this.serviceIntervals[0].new,
                                grease: this.serviceIntervals[1].new,
                                chainDrive: this.serviceIntervals[2].new,
                                motor: this.serviceIntervals[3].new,
                                counterblade: this.serviceIntervals[4].new })];
                    case 1:
                        updatedIntervals = (_a.sent()).data;
                        this.serviceIntervals = [];
                        this.setIntervalValues(updatedIntervals);
                        this.saved = true;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceSetupServiceParametersView.prototype.resetToFactoryDefaults = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var getIntervals;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.saved = false;
                        return [4 /*yield*/, axios.get("devicesensorlog/resetintervals", { params: { serialNumber: this.device.serial } })];
                    case 1:
                        getIntervals = (_a.sent()).data;
                        this.setIntervalValues(getIntervals);
                        this.loading = false;
                        this.saved = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceSetupServiceParametersView.prototype.getIntervals = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var getIntervals, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.get("devicesensorlog/intervals", { params: { serialNumber: this.device.serial } })];
                    case 2:
                        getIntervals = (_a.sent()).data;
                        this.setIntervalValues(getIntervals);
                        this.getLastRuntime();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.warningMessage = this.$t("deviceSetupServiceParametersView.limitedFeaturesAvailable");
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceSetupServiceParametersView.prototype.getLastRuntime = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, axios.get("devicesensorlog/runtime", { params: { serialNumber: this.device.serial } })];
                    case 1:
                        _a.lastRuntime = (_b.sent()).data;
                        this.runtime = this.lastRuntime.runtime;
                        if (this.runtime > 0)
                            this.lastRuntime.runtimeDateString = "(" + new Date(this.lastRuntime.runtimeDateString).toLocaleDateString().split('T')[0] + ")";
                        return [2 /*return*/];
                }
            });
        });
    };
    DeviceSetupServiceParametersView.prototype.setIntervalValues = function (intervalValues) {
        this.serviceIntervals = [];
        this.serviceIntervals.push({ name: this.$t("deviceMaintenance.serviceBladeChange").toString(), current: intervalValues.blade, new: intervalValues.blade });
        this.serviceIntervals.push({ name: this.$t("deviceMaintenance.serviceGreasing").toString(), current: intervalValues.grease, new: intervalValues.grease });
        this.serviceIntervals.push({ name: this.$t("deviceMaintenance.serviceChainDriveChange").toString(), current: intervalValues.chainDrive, new: intervalValues.chainDrive });
        this.serviceIntervals.push({ name: this.$t("deviceMaintenance.serviceMotorChange").toString(), current: intervalValues.motor, new: intervalValues.motor });
        this.serviceIntervals.push({ name: this.$t("deviceMaintenance.serviceCounterBladeChange").toString(), current: intervalValues.counterBlade, new: intervalValues.counterBlade });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceSetupServiceParametersView.prototype, "device", void 0);
    DeviceSetupServiceParametersView = tslib_1.__decorate([
        Component
    ], DeviceSetupServiceParametersView);
    return DeviceSetupServiceParametersView;
}(Vue));
export default DeviceSetupServiceParametersView;
